export const appMiscRoutes = [
	{
		path: ':catchAll(.*)',
		name: 'Private Not Found',
		component: () => import('@/views/pages/NotFound/NotFound.vue')
	},
	{
		path: 'error',
		name: 'Private Error',
		component: () => import('@/views/pages/Error/Error.vue')
	},
	{
		path: 'access-denied',
		name: 'Private Access Denied',
		component: () => import('@/views/pages/AccessDenied/Access.vue')
	}
];
